export const apiEndpoints = {
    auth: {
        sendSms: `/auth/send_otp`,
        resendSms: `/auth/resend_sms`,
        createToken: `/auth/token`,
        refreshToken: `/auth/token_refresh`,
        validateToken: `/validate_token`,
        upgradeToken: `/auth/upgrade_token`,
        apple: '/auth/apple/connect',
        googleLoginInit: '/auth/google/init',
        validatePhone: '/auth/validate_phone',
    },
    menu: {
        login: '/v1/menu/auth/login',
        refresh: '/v1/menu/auth/refresh',
    },
    profile: {
        profile: '/account/profile',
        settings: '/account/profile/settings',
        activities: '/account/profile/activities',
        consent: '/account/profile/consent',
    },
};

export default apiEndpoints;
